import React from "react";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import ContactSection from "../components/ContactSection";
import getInTouch from "../assets/white.png";
import ContactForm from "../components/ContactForm";
import aboutBanner2 from "../assets/about_banner2.png";

const Contact = () => {
  return (
    <div>
      <Header />
      <div className="relative w-full">
        {/* Banner Image */}
        <img
          src={aboutBanner2}
          alt="aboutBanner"
          className="w-full h-auto object-cover banner-img"
        />

        {/* Overlay Text */}
        <div className="absolute inset-0 flex items-center justify-center">
          <h2
            data-aos="fade-up"
            className="text-white text-4xl md:text-5xl title-font-heading"
          >
            Contact us
          </h2>
        </div>
      </div>
      <ContactSection />

      <ContactForm />
      {/* Get in Touch */}
      <section className=" bg-[#153280]  form-top text-white px-6 py-12 md:px-28 md:py-10">
        <div className="flex flex-col md:flex-row items-center justify-between">
          {/* Left: Text */}
          <div className="cta-content">
            <h3 data-aos="fade-up">Let’s Build</h3>
            <p data-aos="fade-up">
              Whether it’s a redevelopment opportunity, a new tower, or project
              management consultancy—you can rely on Bhagwati Engineering to
              deliver, structurally and strategically.
            </p>
            {/* <Link to="#contact">
              <button
                data-aos="fade-up"
                className="uppercase bg-white text-[#1C3E9A] px-6 py-2 mt-6 rounded-full"
              >
                Get a Quote
              </button>
            </Link> */}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Contact;
